// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ADD_PRODUCTS_BANNER_DESCRIPTION = "P\u0159idej si do profilu sv\u016fj TOP v\u00fdb\u011br a\u00a0inspiruj ostatn\u00ed.";
export const ADD_PRODUCTS_BANNER_TITLE = "Pomoz mamink\u00e1m s v\u00fdb\u011brem spr\u00e1vn\u00e9 v\u00fdbavi\u010dky";
